import React from "react";
import Modal from "../shared/Modal";
import "./ModalCreatingPolicyInterstitial.css";
import { Spinner } from "../common/Spinner";

interface ModalCreatingPolicyInterstitial {
  isOpen: boolean;
}

export const ModalCreatingPolicyInterstitial = ({
  isOpen,
}: ModalCreatingPolicyInterstitial) => {
  const onClose = () => {
    return;
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      style={{
        width: "500px",
      }}
      canClose={false}
      escapeToClose={false}
      allowClickout={false}>
      <div className="modal-creating-policy-interstitial">
        <div className="modal-creating-policy-interstitial-title">
          <h2>Loading...</h2>
        </div>
        <div className="modal-creating-policy-interstitial-body">
          <Spinner align="center" size="large" />
        </div>
      </div>
    </Modal>
  );
};
